<template>
  <div class="default">
    <div class="sch-header">
      <router-link to="schoolInfo">
        <img class="header-1" src="./../assets/img/zncIcon-2.png" />
      </router-link>
	    <span class="header-2" @click="backTo()">
		    <img src="./../assets/img/backHome.svg" style="height: 0.4rem; margin-top: 0.04rem"/>
	    </span>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      isActive: 0,
    };
  },
  created() {},
  methods: {
    backTo: function () {
      window.location.href = "https://m.zhinanche.com/#/";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.default {
  background: #f5f5f5;
  //width: 7.5rem;
  .sch-header {
    // position: relative;
    background: #ffffff;
    height: 0.96rem;
    padding: 0.25rem 0.2rem;
    box-shadow: 0 0.01rem 0.01rem #cad2e8;
    a {
      display: block;
      height: 0.42rem;
      float: left;
      .header-1 {
        // width: 4.4rem;
        height: 100%;
      }
    }
    .header-2 {
	    display: flex;
	    height: 0.42rem;
	    font-size: 0.2rem;
	    line-height: 0.45rem;
	    font-weight: 500;
	    color: #999999;
	    //width: 2rem;
      float: right;
    }
  }
  .float_modeule {
    position: fixed;
    top: 0.9rem;
    right: 0;
    z-index: 10;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/zncMain.vue